import { useAuthStore } from '../../store/authStore';
import { useQuery } from 'react-query';
import { reporteService } from '../../services/reporteService';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  const { user } = useAuthStore();

  const { data: dashboardData } = useQuery(
    'dashboard',
    () => reporteService.getDashboard()
  );

  const dashboard = dashboardData?.data;

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Bienvenido, {user?.name || 'Usuario'}
        </h1>
        <p className="text-gray-600">
          Desde aquí podrás gestionar toda la configuración de tu plataforma POS.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-sm font-medium text-gray-500 mb-2">Ventas del Día</h3>
          <p className="text-3xl font-bold text-gray-900">
            ${dashboard?.ventasHoy.toFixed(2) || '0.00'}
          </p>
          <p className="text-sm text-gray-500 mt-2">Total del día</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-sm font-medium text-gray-500 mb-2">Órdenes del Día</h3>
          <p className="text-3xl font-bold text-gray-900">
            {dashboard?.ordenesHoy || 0}
          </p>
          <p className="text-sm text-gray-500 mt-2">Completadas hoy</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-sm font-medium text-gray-500 mb-2">Sesiones Abiertas</h3>
          <p className="text-3xl font-bold text-gray-900">
            {dashboard?.sesionesAbiertas || 0}
          </p>
          <p className="text-sm text-gray-500 mt-2">Cajas activas</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-sm font-medium text-gray-500 mb-2">Ticket Promedio</h3>
          <p className="text-3xl font-bold text-gray-900">
            ${dashboard?.ordenesHoy ? (dashboard.ventasHoy / dashboard.ordenesHoy).toFixed(2) : '0.00'}
          </p>
          <p className="text-sm text-gray-500 mt-2">Por orden</p>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold mb-4">Accesos Rápidos</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <Link
            to="/pos"
            className="p-4 border rounded hover:bg-gray-50 transition text-center"
          >
            <div className="font-medium">Punto de Venta</div>
          </Link>
          <Link
            to="/sesiones-caja"
            className="p-4 border rounded hover:bg-gray-50 transition text-center"
          >
            <div className="font-medium">Sesiones de Caja</div>
          </Link>
          <Link
            to="/reportes/ventas"
            className="p-4 border rounded hover:bg-gray-50 transition text-center"
          >
            <div className="font-medium">Reportes</div>
          </Link>
          <Link
            to="/inventario"
            className="p-4 border rounded hover:bg-gray-50 transition text-center"
          >
            <div className="font-medium">Inventario</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

